/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hx-pull-right[_ngcontent-%COMP%]{float:right!important}.margin-top-5[_ngcontent-%COMP%]{margin-top:5px}.margin-bottom-5[_ngcontent-%COMP%]{margin-bottom:5px}.edit_mode[_ngcontent-%COMP%]{border:1px solid #f75404}.big_title[_ngcontent-%COMP%]{padding:20px;color:#fff;font-size:140%}.hx-status-text[_ngcontent-%COMP%]{font-weight:700}"];
export { styles as styles };
